import React from 'react';

/** AboutUs.jsx — beige-theme redesign. Drop-in replacement. Self-contained. */
const AboutUs = () => (
  <section id="about-us" className="cai-ab">
    <div className="cai-ab-inner">
      <div className="cai-ab-head"><h2 className="cai-ab-h2">Built to automate. Designed to deliver.</h2></div>
      <div className="cai-ab-story">
        <p className="cai-ab-lead">Manual processes and disconnected systems represent <span className="cai-ab-hl">measurable cost — typically 20–40% of operational overhead.</span> We identify, quantify, and eliminate that cost through purpose-built automation.</p>
        <p className="cai-ab-body">We scope, build, deploy, and manage automation across voice, workflow, document, and integration layers. Your team runs the business. We run the technology.</p>
      </div>
      <div className="cai-ab-grid">
        <div className="cai-ab-card cai-ab-card-dark">
          <div className="cai-ab-emoji">🎯</div>
          <h3 className="cai-ab-card-title">Engagement model</h3>
          <p className="cai-ab-card-body">We audit your operations, build automation to specification, and manage the deployed stack. Fixed scope. Predictable cost. Measurable outcome.</p>
        </div>
        <div className="cai-ab-card cai-ab-card-olive">
          <div className="cai-ab-emoji">👁️</div>
          <h3 className="cai-ab-card-title">Client profile</h3>
          <p className="cai-ab-card-body">We work with businesses from SME to enterprise scale. Typical engagements reduce operational overhead by 30–85%.</p>
        </div>
      </div>
    </div>
    <style>{`
      .cai-ab { background: #ECEAE3; padding: 96px 40px 0; }
      .cai-ab-inner { max-width: 1100px; margin: 0 auto; }
      .cai-ab-head { text-align: center; margin-bottom: 44px; }
      .cai-ab-h2 { font-size: 42px; font-weight: 800; letter-spacing: -0.025em; margin: 0; color: #1A1A18; }
      .cai-ab-story { background: #fff; border-radius: 24px; padding: 48px 56px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); max-width: 860px; margin: 0 auto 32px; }
      .cai-ab-lead { font-size: 20px; line-height: 1.6; color: #3A3730; margin: 0 0 18px; }
      .cai-ab-hl { color: #C0492A; font-weight: 600; }
      .cai-ab-body { font-size: 18px; line-height: 1.6; color: #5A564D; margin: 0; }
      .cai-ab-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 22px; max-width: 860px; margin: 0 auto; }
      .cai-ab-card { border-radius: 20px; padding: 36px; color: #fff; }
      .cai-ab-card-dark { background: #1A1A18; }
      .cai-ab-card-olive { background: #5E6B39; }
      .cai-ab-emoji { font-size: 28px; margin-bottom: 14px; }
      .cai-ab-card-title { margin: 0 0 12px; font-size: 22px; font-weight: 700; }
      .cai-ab-card-dark .cai-ab-card-body { color: #C5C0B6; }
      .cai-ab-card-olive .cai-ab-card-body { color: #E2E5D6; }
      .cai-ab-card-body { margin: 0; font-size: 15px; line-height: 1.6; }
      @media (max-width: 900px) { .cai-ab { padding: 64px 22px 0; } .cai-ab-h2 { font-size: 32px; } .cai-ab-story { padding: 32px 26px; } .cai-ab-grid { grid-template-columns: 1fr; } }
    `}</style>
  </section>
);

export default AboutUs;
